import request from "@/utils/request";

// 获取验证码
export function getCode(phone) {
  //   console.log('[请求] 获取验证码:', phone);
  return request
    .post("/web/reservation/code", {
      lang: 4,
      req_type: 2,
      phone,
    })
    .then((res) => {
      // console.log('[成功] 获取验证码响应:', res);
      return res;
    })
    .catch((err) => {
      // console.error('[失败] 获取验证码:', err);
      throw err;
    });
}

// 提交预约
export function makeReservation(code, phone) {
  // console.log('[请求] 提交预约:', code, phone);
  return request
    .post("/web/reservation/make", {
      lang: 4,
      req_type: 2,
      code,
      phone,
    })
    .then((res) => {
      // console.log('[成功] 提交预约响应:', res);
      return res;
    })
    .catch((err) => {
      // console.error('[失败] 提交预约:', err);
      throw err;
    });
}

// 新闻列表
export function getNewsList(page, size, type) {
  //   console.log('[请求] 获取新闻列表:', page, size);
  return request
    .post("/web/article/list", {
      page,
      size,
      type,
      zone: 4,
      status: 2,
    })
    .then((res) => {
      // console.log('[成功] 新闻列表:', res);
      return res;
    })
    .catch((err) => {
      // console.error('[失败] 新闻列表:', err);
      throw err;
    });
}

// 新闻详情
export function getNewsDetail(id) {
  //   console.log('[请求] 获取新闻详情:', id);
  return request
    .post("/web/article/get", { id })
    .then((res) => {
      // console.log('[成功] 新闻详情:', res);
      return res;
    })
    .catch((err) => {
      // console.error('[失败] 新闻详情:', err);
      throw err;
    });
}

// 预约数量
export function getMilestone() {
  return request
    .post("/web/milestone", {
      act_id: 1,
    })
    .then((res) => {
      // console.log('[成功] 预约数量:', res);
      return res;
    })
    .catch((err) => {
      // console.error('[失败] 预约数量:', err);
      throw err;
    });
}

// 微信QQ登录
export function QcWxLogin(data) {
  return request
    .post("/web/auth/cn", data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

// 查询是否已预约
export function getReservation() {
  return request
    .post("/web/reservation/status", { act_id: 1 })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}
